const Tag = ({ name, color = 'primary', className="" }) => {
  const base =
    'w-fit text-bodyMobile md:text-bodyDesktop font-chivoMono uppercase p-[12px] lg:px-[15px] lg:py-[5px]'
  const variants = {
    primary: 'bg-background text-olive',
    secondary: 'bg-khaki text-background',
  }
  return <span className={`${base} ${variants[color]} ${className}`}>{name}</span>
}

export default Tag
